import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "mobile-menu" }
const _hoisted_2 = { class: "mobile-menu__head" }
const _hoisted_3 = { class: "mobile-menu__head-control" }
const _hoisted_4 = { class: "mobile-menu__functions" }
const _hoisted_5 = { class: "mobile-menu__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ContrastSwitcher = _resolveComponent("ContrastSwitcher")!
  const _component_FontsizeSwitcher = _resolveComponent("FontsizeSwitcher")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_MainLinks = _resolveComponent("MainLinks")!
  const _component_ArticleList = _resolveComponent("ArticleList")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.toggleMobileMenu,
              class: "mobile-menu__menu-switcher",
              variant: "text",
              title: "Menu mobile"
            }, {
              default: _withCtx(() => [
                (!_ctx.showMobileMenu)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      size: "35"
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-menu")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      size: "35"
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-close")
                      ])),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ContrastSwitcher),
            _createVNode(_component_FontsizeSwitcher),
            _createVNode(_component_LanguageSwitcher)
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mobile-menu__breaker" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MainLinks),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mobile-menu__breaker" }, null, -1)),
          _createVNode(_component_ArticleList)
        ])
      ], 512), [
        [_vShow, _ctx.showMobileMenu]
      ])
    ]),
    _: 1
  }))
}